import ch from './ch'
import en from './en'
export default{
    ch,
    en
}